<!-- <h1>NRP DASBHOARD</h1> -->

<div style="width:auto">

  <p><strong>Welcome to NRP DASHBOARD application</strong></p>
  <p>It uses:</p>
  <ul>
    <li><a href='https://powerbi.microsoft.com/'>Power BI</a> for genarating reports</li>
    <li><a href='https://get.asp.net/'>ASP.NET Core</a> and <a
        href='https://msdn.microsoft.com/en-us/library/67ef8sbd.aspx'>C#</a> for cross-platform server-side code</li>
    <li><a href='https://angular.io/'>Angular</a> and <a href='http://www.typescriptlang.org/'>TypeScript</a> for
      client-side code</li>
    <li><a href='https://uiux.corp.vizientinc.com/'>Vizient toolkit</a> for layout and styling</li>
  </ul>

  <p>
    <strong>Useful Links:</strong>
  </p>
  <ul>
    <li>Embed Power BI content into an application: <a
        href='https://docs.microsoft.com/en-us/power-bi/developer/embedded/embed-sample-for-customers'>Click here</a>
    </li>
    <li>Embedding Power BI in Angular: <a
        href='https://medium.com/@krishnaanaril/embedding-power-bi-in-angular-part-1-a1847de9a2e8'>Click here</a>
    </li>
  </ul>
</div>
